// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AcceptancePhotosController from "./acceptance_photos_controller"
application.register("acceptance-photos", AcceptancePhotosController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CartQuantumController from "./cart_quantum_controller"
application.register("cart-quantum", CartQuantumController)

import CategoryTreeController from "./category_tree_controller"
application.register("category-tree", CategoryTreeController)

import CheckoutInfoController from "./checkout_info_controller"
application.register("checkout-info", CheckoutInfoController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import EmailMaskController from "./email_mask_controller"
application.register("email-mask", EmailMaskController)

import FeedbackGalleryController from "./feedback_gallery_controller"
application.register("feedback-gallery", FeedbackGalleryController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FilterResetController from "./filter_reset_controller"
application.register("filter-reset", FilterResetController)

import ImageLoaderController from "./image_loader_controller"
application.register("image-loader", ImageLoaderController)

import InvoiceItemMarksController from "./invoice_item_marks_controller"
application.register("invoice-item-marks", InvoiceItemMarksController)

import InvoiceItemPhotosController from "./invoice_item_photos_controller"
application.register("invoice-item-photos", InvoiceItemPhotosController)

import LeadFormController from "./lead_form_controller"
application.register("lead-form", LeadFormController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NoticeController from "./notice_controller"
application.register("notice", NoticeController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import PriceCalculatorController from "./price_calculator_controller"
application.register("price-calculator", PriceCalculatorController)

import ProductFilterController from "./product_filter_controller"
application.register("product-filter", ProductFilterController)

import ProductModalController from "./product_modal_controller"
application.register("product-modal", ProductModalController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import RegistrationTokenController from "./registration_token_controller"
application.register("registration-token", RegistrationTokenController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import StopPeriodController from "./stop_period_controller"
application.register("stop-period", StopPeriodController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)

import ReturnableContainersController from "./returnable_containers_controller"
application.register("returnable-containers", ReturnableContainersController)
